import { makeApiCall } from '../core';
import type { WeatherForecastAlert } from '@ruta/shared';
import type { ListEnvelope } from '@ruta/shared';

// =====================
// Weather Alerts API
// =====================

export type { WeatherForecastAlert };

export const getWeatherAlerts = async (): Promise<{ alerts: WeatherForecastAlert[] }> => {
  const res = await makeApiCall<ListEnvelope<WeatherForecastAlert>>('GET', '/weather-alerts');
  return { alerts: res.data };
};
